import { T } from "react-translator-component";
import dayjs from "../../util/dayjs";

export const toDisplayedDate = (date?: string) => {
  if (!date) {
    return ''
  }

  const d = dayjs(date);
  if (!d.isValid()) {
    return ''
  }
  return d.format('YYYY/MM/DD')
};

export const toDisplayedTerm = (start_date: string, end_date: string) => {
  const s = toDisplayedDate(start_date);
  const e = toDisplayedDate(end_date);
  if (s && e) {
    return `${s}${T('mng_term_separator')}${e}`
  } else {
    return ''
  }
}
